import axios from "axios"
import React, { Component } from "react"
import AxiosConfig from "src/utilities/AxiosConfig"
//@ts-ignore
import Pdf from "react-to-pdf"
import dayjs from "dayjs"
import { Button, Modal } from "react-bootstrap"
import snackBar from "src/utilities/snackBar/SnackBar"
import mutator from "src/utilities/mutator"
import DynamicFormPaletteTypes from "src/store/DyanmicFormPalette/types"
import DynamicFormTaskTypes from "src/pages/dynamic_forms/Types/DynamicFormTaskTypes"
import DynamicFormTypes from "src/pages/dynamic_forms/Types/DynamicFormsTypes"
import DynamicForm from "src/pages/dynamic_forms/DynamicForm/DynamicForm"
import DynamicFormNormalizedReferenceTypes from "src/pages/dynamic_forms/Types/DynamicFormNormalizedReferenceTypes"
import LDSEllipsis from "src/components/common/LDS/LDSEllipsis/LDSEllipsis"
import TaskManagerTasksModalHeader from "../TaskManagerTaskModalHeader/TaskManagerTaskModalHeader"
import paletteEngine from "src/pages/dynamic_forms/Utils/paletteEngine"
import "./TaskManagerTaskViewer.css"

interface Props {
    task: DynamicFormTaskTypes
    manageParentState: Function
    formReference: DynamicFormNormalizedReferenceTypes
    loggedInUser: { userId: string | number, userName: string }
    palette: Array<DynamicFormPaletteTypes>
}

interface State {
    form: DynamicFormTypes | null
}

class TaskManagerTaskViewer extends Component<Props, State> {

    ref: any = React.createRef()
    date = new Date()
    timeZoneOffset = -this.date.getTimezoneOffset()
    timeFormat = "YYYY/MM/DD h:mm a"

    options = {
    }

    state = {
        form: null
    }

    componentDidMount(): void {
        this.getTaskManagerTaskViewer(this.props.task)
    }

    manageState = (keys: Array<{ key: string, value?: any }>) => {
        this.setState(mutator.mutate(this.state, keys))
    }

    getTaskManagerTaskViewer = (task: DynamicFormTaskTypes) => {
        if (task.CustomFormDataId > 0) {
            axios.get(process.env.REACT_APP_API_URL + `/api/company/GetCompletedDynamicForm/${task.CustomFormDataId}`, AxiosConfig.configValue("min"))
                .then((res) => {
                    let form: DynamicFormTypes = res.data.form
                    form.FieldsSchema = form.FieldsValues
                    this.manageState([{ key: "form", value: form }])
                }).catch(err => {
                    //console.log(err)
                    snackBar({ text: "Error fetching completed form task", type: "error", timeout: 3000 })
                    this.props.manageParentState([{ key: "taskToView", value: null }])
                })
            //@ts-ignore
        } else if (`${this.props.loggedInUser.userId}` === `${this.props.formReference.TargetUserId}`) {
            this.props.manageParentState([{ key: "taskToView", value: null }, { key: "taskToComplete", value: task }])
        } else {
            this.props.manageParentState([{ key: "taskToView", value: null }])
        }
    }

    render() {

        const props = this.props
        const state = this.state
        const backgroundColor = `${paletteEngine.getPaletteColor("formBackgroundColor")}`
        const inputTextColor = `${paletteEngine.getPaletteColor("fieldInputTextColor")}`
        const headerTextColor = `${paletteEngine.getPaletteColor("headerTextColor")}`

        // //console.log("TaskManagerTaskViewer props", props)
        // //console.log("TaskManagerTaskViewer state", state)

        return (
            <div className="TaskManagerTaskViewer">
                <Modal
                    id="task-manager-task-viewer-modal"
                    show={true}
                    backdrop="static"
                    keyboard={true}
                    centered={true}
                    size={"lg"}
                >
                    <Modal.Header style={{ backgroundColor: backgroundColor }}>
                        <TaskManagerTasksModalHeader
                            workFlowId={props.task.DynamicFormWorkFlowId}
                            fetching={state.form ? false : true}
                            saving={false}
                            showDebug={false}
                            backgroundColor={backgroundColor}
                            inputTextColor={inputTextColor}
                            headerTextColor={headerTextColor}
                            manageParentState={() => null}
                        />
                    </Modal.Header>
                    <Modal.Body style={{ backgroundColor: backgroundColor }}>
                        <div className="TaskManagerTaskViewerModalBody">
                            {state.form && <div className="TaskManagerTaskViewerFormWrapper" ref={this.ref}>
                                <div className="TaskManagerTaskViewerFormWrapperUpper">
                                    <DynamicForm
                                        //@ts-ignore
                                        form={state.form}
                                        addOrRemoveColumn={() => null}
                                        submit={() => null}
                                        palette={this.props.palette}
                                        readOnly={true}
                                    />
                                </div>
                                <div className="TaskManagerTaskViewerFormWrapperLower">
                                    <div className="TaskManagerTaskViewerFormWrapperLoweritem">
                                        <span className="material-icons" style={{ color: headerTextColor }}>person</span>
                                        {/*@ts-ignore*/}
                                        <p style={{ color: inputTextColor }}>{`Completed by: ${props.formReference.employee.LastName}, ${props.formReference.employee.FirstName}  (id: ${props.formReference.TargetUserId})`}</p>
                                    </div>
                                    <div className="TaskManagerTaskViewerFormWrapperLoweritem">
                                        <span className="material-icons" style={{ color: headerTextColor }}>event</span>
                                        {/*@ts-ignore*/}
                                        <p style={{ color: inputTextColor }}>{`Completed date: ${dayjs(props.task.CompletedDateUTC).utc("z").local().utcOffset(this.timeZoneOffset).format(this.timeFormat)}`}</p>
                                    </div>
                                    {/*@ts-ignore*/}
                                    {state.form.Latitude > 0 && state.form.Longitude > 0 && <div className="TaskManagerTaskViewerFormWrapperLoweritem">
                                        <span className="material-icons" style={{ color: headerTextColor }}>gps_fixed</span>
                                        {/*@ts-ignore*/}
                                        <p style={{ color: inputTextColor }}>{`lat: ${state.form.Latitude}, lng: ${state.form.Longitude}`}</p>
                                    </div>}
                                </div>
                            </div>}
                            {!state.form && <div className="TaskManagerTaskViewerModalBodyWorking">
                                <LDSEllipsis />
                            </div>}
                        </div>
                    </Modal.Body>
                    <Modal.Footer style={{ backgroundColor: backgroundColor }}>
                        <div className="TaskManagerTaskViewerModalFooter">
                            <div className="TaskManagerTaskViewerModalFooterLeft">
                                {/*@ts-ignore*/}
                                {state.form && <Pdf options={this.options} targetRef={this.ref} filename={`${props.formReference.employee.LastName}, ${props.formReference.employee.FirstName}-${state.form.Name}.pdf`}>
                                    {/*@ts-ignore*/}
                                    {({ toPdf }) => <span className="material-icons" onClick={toPdf} style={{ color: headerTextColor }}>download</span>}
                                </Pdf>}
                            </div>
                            <div className="TaskManagerTaskViewerModalFooterRight">
                                <Button variant="secondary" onClick={() => props.manageParentState([{ key: "taskToView", value: null }])}>Back</Button>
                            </div>
                        </div>
                    </Modal.Footer>
                </Modal>
            </div>
        )
    }
}

export default TaskManagerTaskViewer